// All hard (non-router) navigations MUST go through this helper: the app can
// be served under a path prefix (PUBLIC_URL=/new behind the sms.combirds.com
// reverse-proxy rewrite), and raw absolute paths would escape the prefix and
// land on the OLD app. React-Router <Link>/history navigation inherits the
// basename automatically; window.location / <a href> / window.open do NOT.
export const APP_BASE = process.env.PUBLIC_URL || '';

export default function appPath(path) {
  return `${APP_BASE}${path}`;
}
